import React, { useEffect, useState, Component, useMemo, useCallback, useTransition } from "react";
import SEO from '../services/SEO';
import { useTranslation } from "react-i18next";
import { AutoComplete, Button,  Cascader, Checkbox, Col, Form, Input, InputNumber, Row, Select, Alert, Table, Progress } from 'antd';
import TLSGerarCombinacoes from "../components/TLSGerarCombinacoes/TLSGerarCombinacoes";

const GerarCombin = () => {

	window.scrollTo(0, 0);
	const { t, i18n: {changeLanguage, language} } = useTranslation();

	return(
		<div>
			<SEO title="TLS Engenharia" description="Descubra soluções inovadoras em software e tecnologia que impulsionam negócios e simplificam processos. Acesse e explore as últimas tendências tecnológicas!" />
			<h2 className="title is-1">{t("geracao_combinacoes")}</h2>
			<br/>
			<hr/>
			<br/>
			<TLSGerarCombinacoes/>
		</div>
	);
}


export default GerarCombin;